import { Component, OnInit, HostListener } from '@angular/core';
import { detectBody } from '../../app.helpers';
import { AppInformationService } from 'app/core/core.module';

declare var jQuery: any;

@Component({
    standalone: false,
    selector: 'app-basic',
    templateUrl: 'basicLayout.template.html',
})
export class BasicLayoutComponent implements OnInit {
    window: any;
    church: string;

    constructor(private appInfo: AppInformationService) {}

    public ngOnInit() {
        detectBody();
    }

    pleaseWait() {
        return !!this.appInfo && this.appInfo.pleaseWait;
    }

    @HostListener('window:resize')
    public onResize() {
        // console.log('onResize');
        detectBody();
    }
}
